import { cn } from "@/lib/utils";
import { Cpu, Sparkles, AlertCircle, Lock } from "lucide-react";

const CFG = {
  system: { icon: Cpu, cls: "bg-slate-100 border-slate-200 text-slate-700", label: "System" },
  ai: { icon: Sparkles, cls: "bg-emerald-50 border-dashed border-emerald-400 text-emerald-800", label: "AI Projected" },
  approval: { icon: AlertCircle, cls: "bg-amber-100 border-amber-400 text-amber-800", label: "Needs approval" },
  gated: { icon: Lock, cls: "bg-slate-50 border-dashed border-slate-300 text-slate-500", label: "Restricted" },
};

export function GovBadge({ kind = "system", label, className }) {
  const c = CFG[kind] || CFG.system;
  const Icon = c.icon;
  const testid = kind === "ai" ? "governance-ai-badge" : kind === "approval" ? "governance-approval-badge" : `governance-${kind}-badge`;
  return (
    <span data-testid={testid}
      className={cn("inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide", c.cls, className)}>
      <Icon className="h-3 w-3" /> {label || c.label}
    </span>
  );
}
